import React, { useState } from 'react';
import './SupremeTestimonialsManagement.css';

/**
 * 🎯 SUPREME TESTIMONIALS MANAGEMENT COMPONENT 2025
 * 
 * Toggle-Sektion für Supreme Testimonial nach Design-Guide:
 * - 1:1 Text-Edit-Design
 * - Dynamische Supreme Testimonials kompakt zusammengefasst
 * - Avatar-Upload für jedes Testimonial
 * - Add/Remove-Funktionalität
 * - Spezifische Klassennamen
 */
function SupremeTestimonialsManagement({
    testimonials,
    addTestimonial,
    removeTestimonial,
    updateTestimonial,
    uploadTestimonialAvatar,
    uploadingTestimonialIndex,
    editData
}) {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="supreme-testimonials-management">
            {/* Toggle Header */}
            <div 
                className={`supreme-testimonials-header ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleExpanded}
            >
                <div className="supreme-testimonials-header-content">
                    <div className="supreme-testimonials-header-icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M8 1L10 5H14L11 8L12 12L8 10L4 12L5 8L2 5H6L8 1Z" stroke="currentColor" strokeWidth="1.2"/>
                            <circle cx="8" cy="6" r="1.5" fill="currentColor"/>
                            <path d="M6 9h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                    </div>
                    <h3 className="supreme-testimonials-header-title">Testimonials</h3>
                    <div className="supreme-testimonials-counter">
                        {testimonials?.length || 0}
                    </div>
                </div>
                <div className={`supreme-testimonials-toggle-arrow ${isExpanded ? 'expanded' : ''}`}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path 
                            d="M4 6L8 10L12 6" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>

            {/* Expanded Content */}
            {isExpanded && (
                <div className="supreme-testimonials-content">
                    {/* Add Button */}
                    <div className="add-supreme-testimonial-section">
                        <button
                            onClick={addTestimonial}
                            className="add-supreme-testimonial-btn"
                        >
                            <div className="btn-icon">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M7 3V11M3 7H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                            </div>
                            <span>Add New Testimonial</span>
                        </button>
                        <div className="add-supreme-testimonial-hint">
                            Create premium testimonials with avatars and detailed information
                        </div>
                    </div>

                    {/* Testimonials Grid */}
                    {testimonials && testimonials.length > 0 && (
                        <div className="supreme-testimonials-grid">
                            {testimonials.map((testimonial, index) => (
                                <div key={testimonial.id || index} className="supreme-testimonial-edit-card">
                                    {/* Card Header */}
                                    <div className="supreme-testimonial-card-header">
                                        <div className="supreme-testimonial-card-title">
                                            <div className="supreme-testimonial-card-number">{index + 1}</div>
                                            <span>Supreme Testimonial</span>
                                        </div>
                                        <button
                                            onClick={() => removeTestimonial(index)}
                                            className="supreme-testimonial-remove-btn"
                                            title="Remove testimonial"
                                        >
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                            </svg>
                                        </button>
                                    </div>

                                    {/* Avatar Section */}
                                    <div className="supreme-testimonial-avatar-section">
                                        <div className="supreme-testimonial-avatar-preview-container">
                                            <div className="supreme-testimonial-avatar-preview">
                                                {testimonial.avatar ? (
                                                    <img
                                                        src={testimonial.avatar}
                                                        alt={`${testimonial.name || 'Testimonial'} Avatar`}
                                                        className="supreme-testimonial-avatar-img"
                                                    />
                                                ) : (
                                                    <div className="supreme-testimonial-avatar-placeholder">
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                            <circle cx="10" cy="7" r="3" stroke="#dee2e6" strokeWidth="1.5"/>
                                                            <path d="M4 17v-1a4 4 0 014-4h4a4 4 0 014 4v1" stroke="#dee2e6" strokeWidth="1.5" strokeLinecap="round"/>
                                                        </svg>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Avatar Controls */}
                                        <div className="supreme-testimonial-avatar-controls">
                                            <label className="supreme-testimonial-avatar-control-btn upload" title="Upload avatar">
                                                {uploadingTestimonialIndex === index ? (
                                                    <div className="supreme-testimonial-upload-spinner"></div>
                                                ) : (
                                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <path d="M7 1V9M4 4L7 1L10 4M2 9V11C2 12.1 2.9 13 4 13H10C11.1 13 12 12.1 12 11V9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                )}
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => {
                                                        if (e.target.files[0]) {
                                                            uploadTestimonialAvatar(e.target.files[0], index);
                                                        }
                                                    }}
                                                    style={{ display: 'none' }}
                                                />
                                            </label>

                                            {testimonial.avatar && (
                                                <button
                                                    onClick={() => updateTestimonial(index, 'avatar', '')}
                                                    className="supreme-testimonial-avatar-control-btn clear"
                                                    title="Clear avatar"
                                                >
                                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
                                                    </svg>
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    {/* Text Fields */}
                                    <div className="supreme-testimonial-content-section">
                                        <label className="supreme-testimonial-field-label">Testimonial Quote</label>
                                        <textarea
                                            value={testimonial.quote || ''}
                                            onChange={(e) => updateTestimonial(index, 'quote', e.target.value)}
                                            placeholder="Enter testimonial quote..."
                                            className="supreme-testimonial-textarea"
                                            rows={4}
                                        />
                                    </div>

                                    <div className="supreme-testimonial-content-section">
                                        <label className="supreme-testimonial-field-label">Name</label>
                                        <input
                                            type="text"
                                            value={testimonial.name || ''}
                                            onChange={(e) => updateTestimonial(index, 'name', e.target.value)}
                                            placeholder="Enter customer name..."
                                            className="supreme-testimonial-input"
                                        />
                                    </div>

                                    <div className="supreme-testimonial-content-section">
                                        <label className="supreme-testimonial-field-label">Info</label>
                                        <input
                                            type="text"
                                            value={testimonial.info || ''}
                                            onChange={(e) => updateTestimonial(index, 'info', e.target.value)}
                                            placeholder="Enter position, company..."
                                            className="supreme-testimonial-input"
                                        />
                                    </div>

                                    <div className="supreme-testimonial-content-section">
                                        <label className="supreme-testimonial-field-label">Website</label>
                                        <input
                                            type="text"
                                            value={testimonial.website || ''}
                                            onChange={(e) => updateTestimonial(index, 'website', e.target.value)}
                                            placeholder="Enter website URL..."
                                            className="supreme-testimonial-input"
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Empty State */}
                    {(!testimonials || testimonials.length === 0) && (
                        <div className="supreme-testimonials-empty-state">
                            <div className="supreme-testimonials-empty-state-icon">
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                                    <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2" strokeDasharray="3 3" opacity="0.3"/>
                                    <path d="M24 14L26 22H32L27 26L28 34L24 30L20 34L21 26L16 22H22L24 14Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
                                    <circle cx="24" cy="20" r="2" fill="currentColor" opacity="0.5"/>
                                    <path d="M20 28h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
                                </svg>
                            </div>
                            <h4>No Supreme Testimonials Yet</h4>
                            <p>Click "Add New Testimonial" to create your first premium customer review</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default SupremeTestimonialsManagement;
